import { DocVersion, NavItem } from '../../types/docs'

export const versions: DocVersion[] = [
  {
    version: 'latest',
    label: 'Latest',
    releaseDate: '2026-03-01',
    supported: true
  },
  {
    version: 'v1.0.0',
    label: '1.0.0',
    releaseDate: '2025-12-01',
    supported: true
  }
]

const baseNavigation: NavItem[] = [
  {
    title: 'Overview',
    path: ''
  },
  {
    title: 'Installation',
    path: '/installation'
  },
  {
    title: 'User Management',
    path: '/user-management'
  },
  {
    title: 'Application Manual',
    path: '/application-manual',
    children: [
      { title: 'Getting Started', path: '/application-manual' },
      { title: 'Clusters', path: '/application-manual/clusters' },
      { title: 'Services', path: '/application-manual/services' },
      { title: 'Rules', path: '/application-manual/rules' },
      { title: 'Monitoring', path: '/application-manual/monitoring' }
    ]
  },
  {
    title: 'Uninstallation',
    path: '/uninstallation'
  }
]

export function getNavigation(_version: string): NavItem[] {
  // Can customize navigation per version if needed
  return baseNavigation
}

export function getVersion(versionString: string): DocVersion | undefined {
  return versions.find(v => v.version === versionString)
}

export function getLatestVersion(): DocVersion {
  return versions.find(v => v.version === 'latest') || versions[0]
}
